<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card shadow="hover">
					<div slot="header">
						<h5 class="text-center m-0 px-2">{{ this.title }}</h5>
					</div>
					<div class="list-item-container px-2">
						<table class="table-outstanding-status-by-area" style="width: 100%;" cellpadding="2">
							<thead>
								<tr class="">
									<td class="py-2 text-muted">#</td>
									<td class="text-muted"><em>Cost Center</em></td>
									<td class="text text-muted"><em>Unit Name</em></td>
									<td class="text-center text-muted"><em>Ebitda</em></td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in reportdata.data" :key="item.CostCenter">
									<td class="py-2">{{ ++index }}</td>
									<td>{{ item.CostCenter }}</td>
									<td class="text-left">{{ item.StationName }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Ebitda, 0) }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Loader v-if="loading.table" />
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	props: {
        area: {
            type: String,
            default: '',
            //required: false,
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: Penanggalan().bulan,
            //required: false,
        },
        status :{
            type: String,
            default: '',
            //required: false,
        },
        charttypedefault :{
            type: String,
            default: 'piechart',
            //required: false,
        },
    },
	data() {
		return {
			reportdata: [],
            value: 0,
			title: 'BOTTOM 5 EBITDA',
			loading: {
				table: false,
				chart: false,
			},
		}
	},
	watch: {
		area(newVal, oldVal) {
            this.getData();
            //console.log('Area changed from', oldVal, 'to', newVal);
        },
        year(newVal, oldVal) {
            this.getData();
            //console.log('Year changed from', oldVal, 'to', newVal);
        },
        month(newVal, oldVal) {
            this.getData();
            //console.log('Month changed from', oldVal, 'to', newVal);
        }
	}, 
	computed: {
		totalEbitda() {
			return this.reportdata.data.reduce((sum, item) => sum + item.Ebitda, 0);
		},
	},

    mounted() {
		this.getData();
    },
    methods:{
		async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/plunit/ebitdabottomfive?'
			this.urlRequestParams += '&area='+this.area
            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.title = response.data.title;
					this.reportdata = response.data;
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}
</script>


<style>
.list-item-container {
    width: 100%;
    margin: 0 auto;
}

.list-item2 {
	display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.list-item-label {
	width: 60%;
	text-align: left;
	font-weight: normal;
}

.table-outstanding-status-by-area tr td {
	padding: 10px 40x;
}
  </style>